"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalLoadCreator = void 0;
var mappers_1 = require("../mappers");
var consts_1 = require("../consts");
var modalLoadCreator = function (event) {
    var eventData = {
        event: 'modal-load',
        eventInfo: 'modal-load',
        modal: {
            modalName: event.eventData.modal.modalName || consts_1.NOT_AVAILABLE,
        },
        user: {
            loginStatus: event.loggedInUser ? 'logged-in' : 'logged-out',
        },
        pmistore: (0, mappers_1.mapStoreData)(event === null || event === void 0 ? void 0 : event.pmistore),
    };
    return eventData;
};
exports.modalLoadCreator = modalLoadCreator;
